module.exports = __webpack_public_path__ + "img/i_nav_chat_new_on.bd277a54.svg";